function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import mapValues from 'lodash/mapValues';
import some from 'lodash/some';
import { withHotKeys } from 'react-hotkeys';
import NavListItem from '../navListItem/NavListItem';
import Icon from '../icon/Icon';
import { ITEMS_PROP_TYPE } from './constants';
import { TABBABLE_INDEX, UNTABBABLE_INDEX, MOVE_TO_NEXT, MOVE_TO_PREV, MOVE_TO_FIRST, MOVE_TO_LAST, ACTIVATE_ITEM } from '../hotKeys/constants';
import { focusNewPosition, filterNonEmptyItems } from '../hotKeys/util';
import { ACTION_KEY_MAP } from './hotKeys';
import ChevronUpChunkySvg from '../iconography/icons/ChevronUpChunky';
import ChevronDownChunkySvg from '../iconography/icons/ChevronDownChunky';

var _getSymbolType = function _getSymbolType(isExpanded) {
  return isExpanded ? React.createElement(ChevronUpChunkySvg, null) : React.createElement(ChevronDownChunkySvg, null);
};

var _getSymbolColor = function _getSymbolColor(isDisabled) {
  return isDisabled ? 'grey-300' : 'grey-400';
};

var _isItemExpanded = function _isItemExpanded(_ref) {
  var active = _ref.active,
      items = _ref.items;
  return !!active || some(items, _isItemExpanded);
};

var _getExpandedItemsLookup = function _getExpandedItemsLookup(items) {
  return mapValues(items, function (item) {
    return _isItemExpanded(item);
  });
};

var NavList =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(NavList, _React$PureComponent);

  function NavList(props) {
    var _defineProperty2;

    var _this;

    _classCallCheck(this, NavList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NavList).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "hotKeyHandlers", (_defineProperty2 = {}, _defineProperty(_defineProperty2, MOVE_TO_NEXT, function (e) {
      return _this._changeFocusedNavListItem(e, MOVE_TO_NEXT);
    }), _defineProperty(_defineProperty2, MOVE_TO_PREV, function (e) {
      return _this._changeFocusedNavListItem(e, MOVE_TO_PREV);
    }), _defineProperty(_defineProperty2, MOVE_TO_FIRST, function (e) {
      return _this._changeFocusedNavListItem(e, MOVE_TO_FIRST);
    }), _defineProperty(_defineProperty2, MOVE_TO_LAST, function (e) {
      return _this._changeFocusedNavListItem(e, MOVE_TO_LAST);
    }), _defineProperty(_defineProperty2, ACTIVATE_ITEM, function (e) {
      return e.stopPropagation();
    }), _defineProperty2));

    _this.state = {
      expandedItemsLookup: _getExpandedItemsLookup(props.items),
      focusPosition: props.defaultFocusPosition
    };
    return _this;
  }

  _createClass(NavList, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref2) {
      var items = _ref2.items;
      this.setState({
        expandedItemsLookup: _getExpandedItemsLookup(items)
      });
    }
  }, {
    key: "_changeFocusedNavListItem",
    value: function _changeFocusedNavListItem(e, direction) {
      var _this$props = this.props,
          items = _this$props.items,
          preventFocusWrap = _this$props.preventFocusWrap;
      var focusPosition = this.state.focusPosition;
      var nonEmptyItems = filterNonEmptyItems(items);
      var boundFocusNewPosition = focusNewPosition.bind(null, nonEmptyItems, focusPosition, e, preventFocusWrap);
      this.setState(boundFocusNewPosition(direction));
    }
  }, {
    key: "_handleLinkClick",
    value: function _handleLinkClick(index, onActivate) {
      var expandedItemsLookup = this.state.expandedItemsLookup;
      this.setState({
        expandedItemsLookup: _objectSpread({}, expandedItemsLookup, _defineProperty({}, index, !expandedItemsLookup[index]))
      });

      if (onActivate) {
        onActivate();
      }
    } // NOTE: Merging keyboard event with mouse events so that in the case of a mouseOver,
    // the focusPosition is changed from the one determined from keyboard navigation
    // to the one determined by the mouseOver. This removes multiple highlights within
    // the same list. We use position rather than index because NavListItem's can be
    // dividers and we don't want to set  focus on those.

  }, {
    key: "_handleItemTentativeSelect",
    value: function _handleItemTentativeSelect(focusPosition) {
      this.setState({
        focusPosition: focusPosition
      });
    }
  }, {
    key: "_getNavListItems",
    value: function _getNavListItems(items, showSymbols, useAltTheme, defaultFocusPosition) {
      var _this2 = this;

      var _this$state = this.state,
          expandedItemsLookup = _this$state.expandedItemsLookup,
          focusPosition = _this$state.focusPosition;
      var position = -1;
      return items.map(function (_ref3, index) {
        var type = _ref3.type,
            content = _ref3.content,
            secondaryContent = _ref3.secondaryContent,
            path = _ref3.path,
            active = _ref3.active,
            isDisabled = _ref3.isDisabled,
            onActivate = _ref3.onActivate,
            nestedItems = _ref3.items,
            unknownItemProps = _objectWithoutProperties(_ref3, ["type", "content", "secondaryContent", "path", "active", "isDisabled", "onActivate", "items"]);

        var onTentativeSelect;
        var hasNestedItems = !isEmpty(nestedItems);
        var isExpanded = expandedItemsLookup[index];
        var isTentativelySelected;
        var nestedListComponent;
        var symbolComponent;
        var onLinkClick;
        var tabIndex;
        var secondaryContentComponent; // For anchor-link NavListItems, which are used in dropdownMenu,
        // (vs router-link NavListItems), assign incremental position. This excludes
        // any dividers that are used, as we don't want to set tabIndex
        // or focus on those.

        if (type === 'anchor' && defaultFocusPosition !== undefined) {
          position++;
          isTentativelySelected = position === focusPosition;
          tabIndex = isTentativelySelected ? TABBABLE_INDEX : UNTABBABLE_INDEX;
          onTentativeSelect = _this2._handleItemTentativeSelect.bind(_this2, position);
        }

        if (hasNestedItems) {
          onLinkClick = _this2._handleLinkClick.bind(_this2, index, onActivate);

          if (isExpanded) {
            nestedListComponent = React.createElement("div", {
              className: "eds-nav-list__sub-list"
            }, React.createElement(NavList, {
              "data-spec": "eds-subnav-list",
              items: nestedItems,
              useAltTheme: useAltTheme
            }));
          }

          if (showSymbols) {
            symbolComponent = React.createElement("div", {
              className: "eds-nav-list__item__symbol eds-fx--fade-in"
            }, React.createElement(Icon, {
              type: _getSymbolType(isExpanded),
              color: _getSymbolColor(isDisabled)
            }));
          }
        }

        if (secondaryContent) {
          secondaryContentComponent = React.createElement("div", {
            className: "eds-nav-list__item__secondary-contents"
          }, secondaryContent);
        }

        return React.createElement("li", {
          className: "eds-nav-list__item",
          key: path || index,
          "data-spec": "eds-nav-list-item" // Set role to "presentation" to intentionally hide semantics from assistive technologies
          // When the <li> element should not be part of the a11y tree, we want to hide the implied
          // "listitem" role of the <li> element
          ,
          role: "presentation",
          onMouseOver: onTentativeSelect,
          onFocus: onTentativeSelect
        }, React.createElement(NavListItem, _extends({}, unknownItemProps, {
          type: type,
          path: path,
          active: active,
          isDisabled: isDisabled,
          onActivate: onLinkClick,
          useAltTheme: useAltTheme,
          tabIndex: tabIndex,
          isTentativelySelected: isTentativelySelected
        }), React.createElement("div", {
          className: "eds-nav-list__item__contents"
        }, content, symbolComponent), secondaryContentComponent), nestedListComponent);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          items = _this$props2.items,
          active = _this$props2.active,
          displayInline = _this$props2.displayInline,
          useAltTheme = _this$props2.useAltTheme,
          showSymbols = _this$props2.showSymbols,
          defaultFocusPosition = _this$props2.defaultFocusPosition;
      var className = classNames('eds-nav-list', {
        'eds-nav-list--active': active,
        'eds-nav-list--inline': displayInline,
        'eds-nav-list--show-symbols': showSymbols
      });
      return React.createElement("ul", {
        "data-spec": "eds-nav-list",
        className: className,
        role: "menu"
      }, this._getNavListItems(items, showSymbols, useAltTheme, defaultFocusPosition));
    }
  }]);

  return NavList;
}(React.PureComponent);

_defineProperty(NavList, "propTypes", {
  /**
   * Array of list items. Available types are ANCHOR_LINK, ROUTER_LINK, DIVIDER
   */
  items: ITEMS_PROP_TYPE.isRequired,

  /**
   * Display the list inline (Horizontally aligned)
   */
  displayInline: PropTypes.bool,

  /**
   * Whether or not the list is active
   */
  active: PropTypes.bool,

  /**
   * Use alternate theme navList
   */
  useAltTheme: PropTypes.bool,

  /**
   * Shows a symbol / icon next to the menu items with sub items
   */
  showSymbols: PropTypes.bool,

  /**
   * Default position (zero-based) within item list - received from DropdownMenu
   */
  defaultFocusPosition: PropTypes.number,

  /**
   * Whether the navigation for items should be un-wrapped (i.e. no first to last, last to first)
   */
  preventFocusWrap: PropTypes.bool
});

_defineProperty(NavList, "defaultProps", {
  displayInline: false,
  useAltTheme: false,
  showSymbols: false,
  preventFocusWrap: false
});

export default withHotKeys(ACTION_KEY_MAP)(NavList);